var map = {
	"./bmp.svg": 3548,
	"./doc.svg": 3549,
	"./docx.svg": 3550,
	"./file.svg": 872,
	"./jpeg.svg": 3551,
	"./jpg.svg": 3552,
	"./pdf.svg": 3553,
	"./png.svg": 3554,
	"./ppt.svg": 3555,
	"./pptx.svg": 3556,
	"./rar.svg": 3557,
	"./xls.svg": 3558,
	"./xlsx.svg": 3559,
	"./zip.svg": 3560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1390;